module.exports = function() {
  return new Worker(__webpack_public_path__ + "c104a0c76815a4d25e7d.worker.js");
};